export const ZIP_CODE_VALIDATION_PATHS = {
  default: 'zipcode/validate',
  fi: 'fi/zipcode/validate',
  easyPay: 'easypay/zipcode/validate',
};
